// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"e484a72c","97":"50591f7b","284":"93b8d2d2","312":"96bc9a95","316":"d470f48a","391":"28f7595d","505":"4fc94a4b","560":"be594ece","679":"093f4569","746":"f48c57d4","818":"6117286a","820":"b7712bcb","902":"8ddd0669","936":"13ac3a9b"}[chunkId] + ".chunk.js";
};